import React, { useEffect } from 'react';
import { lockCanvas } from 'utils/global';
import styles from './style/modal.module.css';

interface ModalProps {
  active?: boolean,
  children?: React.ReactNode,
  id?: string,
  transparent?: boolean,
}

function Modal({ active, children, id, transparent }:ModalProps) {
  useEffect(() => {
    lockCanvas(active);
  }, [active]);
  return (
    <div
      className={`
        ${styles.modal}
        ${active ? styles.modal_active : ''}
      `}
      id={id}
    >
      <div className={`
        ${styles.modal__content}
        ${transparent ? styles.modal__content_transparent : ''}
      `}
      >
        { children }
      </div>
    </div>
  );
}

Modal.defaultProps = {
  active: false,
  children: null,
  id: '',
  transparent: false,
};

export default Modal;
